import { render, staticRenderFns } from "./vip-info.vue?vue&type=template&id=363ed87d&scoped=true&"
import script from "./vip-info.vue?vue&type=script&lang=js&"
export * from "./vip-info.vue?vue&type=script&lang=js&"
import style0 from "./vip-info.vue?vue&type=style&index=0&id=363ed87d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363ed87d",
  null
  
)

export default component.exports